import React, { useState } from "react"
import { Link } from "gatsby-plugin-intl";
import { getCurrentLangKey } from '../../utils/getCurrentLangKey';
import LanguageData  from "../../data/languages";
import { OtherTranslations } from "../../hooks/queries/OtherTranslations";
import FreeCallLogo from "../../images/fcc-logo-horizontal.svg"
import { ListMenu, Search, HeaderLanguageSwitcher } from "../"
import { getCurrentCountryCode } from "../../utils/getCurrentCountryCode";
import {
  StyledHeader,
  StyledHeaderImage,
  StyledHeaderGoBackToFcc,
} from "../../styledComponents"
import { useWindowSize } from "../../hooks"

import SearchIcon from "../../images/search.svg"
import CrossIcon from "../../images/cross.svg"

export const Header = ({ intl, categories, country_code }) => {

  const languages_info = LanguageData.languages_info;
  const langKey = getCurrentLangKey();
  const data = OtherTranslations();
  const t = data.mb.otherTranslation.localizations.find(item => item.locale === langKey) || data.mb.otherTranslation;


  const windowSize = useWindowSize()
  const [isMenuToggled, switchState] = useState(false)
  const [isSearchToogled, switchSearch] = useState(false)

  country_code = getCurrentCountryCode();

  const switchSearchHandler = () => {
    switchSearch(prev => !prev)
  }

  const searchBlock = isSearchToogled ? (
    windowSize.width > 425 ? (
      <Search />
    ) : (
      <>
        <img src={CrossIcon} onClick={switchSearchHandler} alt="cross icon" />
        <div className="searchBlock">
          <Search type="mobile" />
        </div>
      </>
    )
  ) : (
    <img src={SearchIcon} onClick={switchSearchHandler} alt="search icon" />
  )

  if (windowSize.width >= 1200) {
    return (
      <>
        <StyledHeaderGoBackToFcc>
          <a href="https://www.freeconferencecall.com" title={t.header_go_back_to_fcc} className="go-back-link float-right">
              {t.header_go_back_to_fcc}
            </a>
        </StyledHeaderGoBackToFcc>
        <StyledHeader>
          <a href="https://www.freeconferencecall.com/" className="navbar-logo" title="FreeConferenceCall.com">
            <StyledHeaderImage bg={FreeCallLogo} />
          </a>
          <Link to={`/${country_code}`} language={langKey} title={t.header_home} className="home-link">
            {t.header_home}
          </Link>
          <ListMenu intl={intl} categories={categories} country_code={country_code} />

          <HeaderLanguageSwitcher langKey={langKey} languages_info={languages_info} />
        </StyledHeader>
      </>
    )
  } else {
    return (
      <StyledHeader>
        <a href="https://www.freeconferencecall.com/" className="navbar-logo" title="FreeConferenceCall.com">
          <StyledHeaderImage bg={FreeCallLogo} />
        </a>
        <Link to={`/${country_code}`} language={langKey} title={t.header_home} className="home-link">
          {t.header_home}
        </Link>

        <div className="header_rightSideMob">
          <HeaderLanguageSwitcher langKey={langKey} languages_info={languages_info} />
          <label
            className="menu_btn"
            htmlFor="menu_toggle"
            onClick={() => switchState(!isMenuToggled)}
          >
            <span></span>
          </label>
        </div>
        {isMenuToggled && <ListMenu intl={intl} categories={categories} />}
      </StyledHeader>
    )
  }
}
